import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import Footer from "../../../core/layout/footer/footer";
import EnquireNow from "../../../services/dataCuration/component/enquireNow";
import DataHeaderView from "../dataHeaderView";
import HeaderImage from "../headerImage";
import TabUiView from "../tabUiView";

let s3BaseURLHome = process.env.REACT_APP_S3_PUBLIC_BASE_IMAGE_URL + '/Images/home';

const ThemeDatabaseView = (props) => {
    const {isModelOpen, closeModal, openModel, isXSView} = props;
    const parms = useLocation()

    useEffect(() => {
        // setTimeout(() => {
        //     document.querySelector('.fade-in').classList.add('fade-in-delay');
        // }, 1000);
    }, []);

    const renderThemeDatabase = () => {
        return (
            <div className="fade show pt-2" id="tab_four3">
                <div className={(isXSView ? 'mb-4 pb-3 text-start' : '') + " col-md-7 col-lg-4 col-12 pe-md-0 py-md-0 pb-md-0 px-sm-4"}>
                    <img src={s3BaseURLHome + '/Theme.png'}
                         alt='Theme'
                         className="rounded mb-md-4 pb-md-1 mb-sm-4 pb-sm-3 mb-sm-1 data-section-image-container"
                    />
                </div>
                <div className={ " col-md-12 col-12 text-start px-sm-4"}>
                    <div className={(isXSView ? 'mb-4 ' : '') + "text-dark p-0 mb-2 mb-lg-3 mb-md-4 mb-sm-4 services-section-title mt-4"}>
                        THEME Database
                    </div>
                    <div className='mb-4 news-event-subHeading text-start text-gray'>
                        Biotransformations and metabolic pathways, based in the specific therapy
                        areas.
                        File formats – JSON, RDF, SQL. The information is derived from multiple
                        sources
                        including patents, FDA labels.
                    </div>
                    <button onClick={openModel}
                            className="btn btn-extra-large btn-rounded with-rounded popup-with-move-anim btn-base-color btn-box-shadow text-transform-none position-relative">Explore
                        Now
                        <span className="bg-white text-white rounded-circle px-2 py-2">
                                <i className="fa-solid fa-arrow-right text-dark-gray"></i></span>
                    </button>
                </div>
            </div>

        )
    };

    const renderDataListUI = () => {
        return (
            <div className="bg-white section-divider">
                <div className="page-container">
                    <div className="row ">
                        <div>
                            {renderThemeDatabase()}
                        </div>
                    </div>
                </div>

            </div>
        )
    };

    const renderUI = () => {
        return (
            <div>
                <HeaderImage
                    {...props}
                    currentDatabase={'Theme'}
                />
                <div className="page-container">
                    <div className='pt-4'>
                        <TabUiView {...props}/>
                    </div>
                </div>
                {renderDataListUI()}
                {isModelOpen &&
                <EnquireNow
                    closeModal={closeModal}
                />
                }
            </div>
        )

    };

    return (
        <div>
            {renderUI()}
            <Footer {...props}/>
        </div>
    );
};

export default ThemeDatabaseView;
